module.exports = __webpack_public_path__ + "static/media/16.550f2ccc.jpg";